/** @format */

import { ReactComponent as Trash } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as Plus } from "bootstrap-icons/icons/plus-lg.svg";
import { ResourceLink } from "../../../types";
import { Alert, Button, FloatingLabel, Form } from "react-bootstrap";
import { isSecureLink } from "../../../utils/functions";
import { LinksAction } from "./ResourceLinksReducer";
import { useTranslation } from "react-i18next";

type Props = {
  disabled: boolean;
  category: string;
  categoryOffset: number; // The number of links before this link
  files: ResourceLink[];
  dispatch: (action: LinksAction) => void; // wrapper to send an action to the parent components reducer
};
const AddLink: React.FC<Props> = ({
  disabled,
  category,
  categoryOffset,
  files,
  dispatch,
}) => {
  const { t: _ } = useTranslation();

  if (disabled) {
    return <p className="text-danger m-2">{_("Invalid category name")}</p>;
  } else {
    return (
      <div className="ms-4 me-4  links-container mb-4">
        <h5 className="mt-3 mb-2">{_("Links")}</h5>
        {files.map((link, linkIndex) => (
          <div key={linkIndex} className="files">
            <Alert variant="secondary">
              <div className="section-actions mb-1">
                <h5>{_("File") + " (" + (linkIndex + 1) + ")"} </h5>
                <Button
                  className="action-button"
                  title={_("Delete link")}
                  onClick={() => {
                    dispatch({
                      type: "deleteLink",
                      payload: {
                        linkIndex: categoryOffset + linkIndex,
                      },
                    });
                  }}
                >
                  <Trash />
                </Button>
              </div>
              <Form.Group>
                <FloatingLabel controlId="floatingInput" label={_("Link")}>
                  <Form.Control
                    placeholder={_("Link")}
                    name="url"
                    aria-describedby="Url input"
                    isInvalid={link.src === "" || !isSecureLink(link.src)}
                    aria-label="Url input"
                    role="input"
                    className="mb-2"
                    value={link.src}
                    data-testid={"fileLink" + linkIndex}
                    onChange={(e) => {
                      dispatch({
                        type: "updateLinkSrc",
                        payload: {
                          linkIndex: categoryOffset + linkIndex,
                          newSrc: e.target.value,
                        },
                      });
                    }}
                  />
                </FloatingLabel>
                <Form.Control.Feedback type="invalid">
                  {_("Please enter a secure link (https)")}
                </Form.Control.Feedback>

                <FloatingLabel label={_("Title")} controlId="floatingInput">
                  <Form.Control
                    data-testid={"fileTitle" + linkIndex}
                    placeholder={_("Title")}
                    name="fileName"
                    aria-describedby="Title input"
                    aria-label="Title input"
                    role="input"
                    className="mb-2"
                    isInvalid={link.label === ""}
                    value={link.label}
                    onChange={(e) => {
                      dispatch({
                        type: "updateLinkTitle",
                        payload: {
                          linkIndex: categoryOffset + linkIndex,
                          newTitle: e.target.value,
                        },
                      });
                    }}
                  />
                </FloatingLabel>
              </Form.Group>
            </Alert>
          </div>
        ))}
        <div className="d-flex gap-2">
          <Button
            variant="editing"
            onClick={() =>
              dispatch({
                type: "newLink",
                payload: { linkIndex: categoryOffset, category: category },
              })
            }
            data-testid="addFile"
            title={_("New link")}
          >
            <Plus />
          </Button>
        </div>
      </div>
    );
  }
};

export default AddLink;
